import { render, staticRenderFns } from "./pix-loader.vue?vue&type=template&id=a3a1e934&scoped=true&"
import script from "./pix-loader.vue?vue&type=script&lang=js&"
export * from "./pix-loader.vue?vue&type=script&lang=js&"
import style0 from "./pix-loader.vue?vue&type=style&index=0&id=a3a1e934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a1e934",
  null
  
)

export default component.exports